module.exports = "/_next/static/files/4f672bb32835c00654f6388329c1e7e1.jpg";